// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"202444a3","488":"4d201857","506":"6698a49d"}[chunkId] + ".chunk.js";
};